import React from 'react'

import { Column, Row, Text } from 'Components/UI'

import { Line } from './styles'

import { Address } from '../types'

type Props = {
  data?: Address
}

function AddressRow({ data }: Props) {
  if (!data) return null

  return (
    <Row gap={7}>
      <Line mt={4} />

      <Column gap={3}>
        <Text body20 medium title>
          {data.title}
        </Text>

        <Text body body16 semiLight>
          {data.caption}
        </Text>
      </Column>
    </Row>
  )
}

export default AddressRow
